"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventInventoryPanes;
(function (EventInventoryPanes) {
    EventInventoryPanes[EventInventoryPanes["EventInventoryRequests"] = 1] = "EventInventoryRequests";
    EventInventoryPanes[EventInventoryPanes["EventInventory"] = 2] = "EventInventory";
    EventInventoryPanes[EventInventoryPanes["Notes"] = 3] = "Notes";
})(EventInventoryPanes || (EventInventoryPanes = {}));
exports.default = EventInventoryPanes;
